<div *blockUI="'show-loader'">
    <div class="modal-body">
        <div class="flex text-center flex-col w-full">
            <p>Please wait while the the data file is being generated</p>           
        </div>
    </div>
</div>